import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Clock } from 'lucide-react';
import Seo from '@/components/Seo';
import Footer from '@/components/Footer';
import { blogArticles } from '@/data/blogArticles';

const BASE_URL = 'https://taxiyellowcabcorsica.fr';

const JSON_LD = {
  "@context": "https://schema.org",
  "@type": "Blog",
  "name": "Le blog Yellow Cab Corsica",
  "url": `${BASE_URL}/blog`,
  "publisher": { "@type": "LocalBusiness", "name": "Taxis Yellow Cab Corsica", "url": BASE_URL }
};

const formatDate = (d) => new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });

const Blog = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="bg-[#0A0A0A]" data-testid="blog-page">
      <Seo
        title="Blog | Conseils & Guides Corse-du-Sud | Yellow Cab Corsica"
        description="Guides pratiques et conseils de votre taxi local : que faire à Porticcio, transferts aéroport Ajaccio, se déplacer en Corse-du-Sud. Le blog Yellow Cab Corsica."
        canonical={`${BASE_URL}/blog`}
        jsonLd={JSON_LD}
      />

      <section className="pt-14 pb-12 px-4 border-b border-white/5">
        <div className="max-w-4xl mx-auto">
          <nav className="flex items-center gap-1.5 text-xs text-[#555] mb-8" aria-label="Fil d'ariane">
            <Link to="/" className="hover:text-[#A3A3A3] transition-colors">Accueil</Link>
            <ChevronRight size={12} />
            <span className="text-[#A3A3A3]">Blog</span>
          </nav>
          <p className="text-xs uppercase tracking-[0.2em] text-[#EAB308] font-semibold mb-3">LE BLOG</p>
          <h1 className="text-4xl sm:text-5xl font-light text-white tracking-tight mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Conseils & guides <span className="text-[#EAB308]">Corse-du-Sud</span>
          </h1>
          <p className="text-[#A3A3A3] text-base md:text-lg max-w-2xl">
            Les bons plans et conseils pratiques de votre taxi local : Porticcio, Ajaccio, transferts et découvertes.
          </p>
        </div>
      </section>

      <section className="py-14 px-4">
        <div className="max-w-4xl mx-auto space-y-4">
          {blogArticles.map((a) => (
            <Link key={a.slug} to={`/blog/${a.slug}`} data-testid={`blog-card-${a.slug}`}
              className="block bg-[#1A1A1A] border border-white/5 hover:border-[#EAB308]/30 rounded-2xl p-6 sm:p-8 group transition-all">
              <div className="flex items-center gap-3 text-xs text-[#555] mb-3">
                <span>{formatDate(a.date)}</span>
                <span className="flex items-center gap-1"><Clock size={11} /> {a.readTime}</span>
              </div>
              <h2 className="text-xl sm:text-2xl font-medium text-white mb-3 group-hover:text-[#EAB308] transition-colors" style={{ fontFamily: 'Outfit, sans-serif' }}>
                {a.title}
              </h2>
              <p className="text-[#A3A3A3] text-sm leading-relaxed mb-4">{a.excerpt}</p>
              <span className="inline-flex items-center gap-1.5 text-[#EAB308] text-sm font-medium">
                Lire l'article <ChevronRight size={14} className="group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
      <div className="h-16 md:h-14" aria-hidden="true" />
    </main>
  );
};

export default Blog;
